var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"accordion accordion-bordered group-col"},[_c('details',{staticClass:"accordion-item",attrs:{"open":_vm.expanded}},[_c('summary',[_vm._v(_vm._s(_vm.provider))]),_c('article',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }